import LoginIcon from "@mui/icons-material/Login";
import { EmployeeServicePath, ADMIN_LOGIN } from "utils/constants";
import SuperLogin from "./SuperLogin";
import permissions from "app/permissions";

export const resources = {
  isMenu: true,
  icon: <LoginIcon />,
  name: EmployeeServicePath + ADMIN_LOGIN,
  title: "Admin Login",
  list: <SuperLogin />,
  permission: permissions.adminOnly,
};
